import { useEffect, useState } from "react";
import { BarAnalytics } from "./BarAnaylitics";
import { BarAnalyticsDisplayContainer } from "./BarAnalyticsDisplayStyle";
import { useTheme } from "styled-components";
import { useAppSelector } from "../../Hooks/Hooks";
import { selectMassagedTimeData } from "../../Redux/Data/DataSlice";
import { NameValuePair } from "../../Types/DataTypes";

export const BarAnalyticsDisplay: React.FC = () => {
    const [max, setMax] = useState<number>();

    const massagedTimeData = useAppSelector(selectMassagedTimeData);
    const theme = useTheme();

    useEffect(() => {
        setMax(
            Math.max(
                ...massagedTimeData.map((obj: NameValuePair) => {
                    return obj.value;
                })
            )
        );
    }, [massagedTimeData]);

    return (
        <BarAnalyticsDisplayContainer>
            {massagedTimeData
                ? massagedTimeData.map(
                      (dataPoint: NameValuePair, idx: number) => {
                          return (
                              <BarAnalytics
                                  animationTimeBar={theme.animationTime.long}
                                  percent={
                                      max ? (dataPoint.value / max) * 100 : 0
                                  }
                                  width={100}
                                  max={max}
                                  lowerBound=" "
                                  upperBound=" "
                                  displayValue={true}
                                  label={dataPoint.name}
                                  showVerticalBar={false}
                                  height={18}
                                  key={idx}
                              />
                          );
                      }
                  )
                : ""}
        </BarAnalyticsDisplayContainer>
    );
};
